import { BlankLayout } from '@/components/layouts';

export default {
  path: '/system-text',
  name: 'System.Text',
  component: BlankLayout,
  meta: { module: '系统文本' },
  children: [
    {
      path: '/system-text/about',
      alias: '/about',
      name: 'About',
      component: () => import(/* webpackChunkName: 'about' */ '@/views/system-text/About.vue'),
      meta: { title: '关于三维家设计师', hideBanner: true },
    },
    {
      path: '/system-text/registration-agreement',
      alias: '/registration-agreement',
      name: 'Registration.Agreement',
      component: () => import(/* webpackChunkName: 'registration-agreement' */ '@/views/system-text/RegistrationAgreement.vue'),
      meta: { title: '用户服务协议', hideBanner: true },
    },
    {
      path: '/system-text/privacy-policy',
      alias: '/privacy-policy',
      name: 'Privacy.Policy',
      component: () => import(/* webpackChunkName: 'privacy-policy' */ '@/views/system-text/PrivacyPolicy.vue'),
      meta: { title: '隐私权政策', hideBanner: true },
    },
    {
      path: '/system-text/channel-info',
      alias: '/channel-info',
      name: 'Channel.Info',
      component: () => import(/* webpackChunkName: 'channel-info' */ '@/views/system-text/ChannelInfo.vue'),
      meta: { title: '作品营销', hideBanner: true },
    },
    {
      path: '/system-text/share-info',
      alias: '/share-info',
      name: 'Share.Info',
      component: () => import(/* webpackChunkName: 'share-info' */ '@/views/system-text/ShareInfo.vue'),
      meta: { title: '个人营销', hideBanner: true },
    },
    {
      path: '/system-text/market-info',
      alias: '/market-info',
      name: 'Market.Info',
      component: () => import(/* webpackChunkName: 'market-info' */ '@/views/system-text/MarketInfo.vue'),
      meta: { title: '营销变现', hideBanner: true },
    },
    {
      path: '/system-text/third-part-info',
      alias: '/third-part-info',
      name: 'Third.Part.Info',
      component: () => import(/* webpackChunkName: 'third-part-info' */ '@/views/system-text/ThirdPartServiceInfo.vue'),
      meta: { title: '第三方SDK收集使用信息说明', hideBanner: true },
    },
    {
      path: '/system-text/app-auth-info',
      alias: '/app-auth-info',
      name: 'App.Auth.Info',
      component: () => import(/* webpackChunkName: 'app-auth-info' */ '@/views/system-text/AppAuthInfo.vue'),
      meta: { hideBanner: true },
    },
  ],
};
